"use client";

import { Dispatch, SetStateAction } from "react";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

interface ProximityFieldProps {
  className?: string;
  proximity: number | "";
  setProximity: Dispatch<SetStateAction<number | "">>;
}

export default function ProximityField({
  proximity,
  setProximity,
  className,
}: ProximityFieldProps) {
  return (
    <div className={className}>
      <TextField
        label="Within..."
        placeholder="15"
        fullWidth
        value={proximity}
        onChange={(event) => {
          const newValue = parseInt(event.target.value);
          if (!Number.isNaN(newValue) && newValue >= 0) {
            setProximity(newValue);
          } else if (event.target.value === "") {
            setProximity("");
          }
        }}
        name={proximity === "" ? undefined : "proximity"}
        inputMode="numeric"
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  onClick={() => {
                    if (proximity === "") {
                      setProximity(14);
                    } else if (proximity > 0) {
                      setProximity(proximity - 1);
                    }
                  }}
                >
                  <RemoveIcon />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={() => {
                    if (proximity === "") {
                      setProximity(16);
                    } else {
                      setProximity(proximity + 1);
                    }
                  }}
                >
                  <AddIcon />
                </IconButton>
                seconds
              </InputAdornment>
            ),
          },
          formHelperText: {
            className: "mx-0",
          },
        }}
        helperText="Only return results where both terms appear together within this time window."
      />
    </div>
  );
}

